import { render, staticRenderFns } from "./AccountInvoices.vue?vue&type=template&id=3878eaf2"
import script from "./AccountInvoices.vue?vue&type=script&lang=ts"
export * from "./AccountInvoices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3878eaf2')) {
      api.createRecord('3878eaf2', component.options)
    } else {
      api.reload('3878eaf2', component.options)
    }
    module.hot.accept("./AccountInvoices.vue?vue&type=template&id=3878eaf2", function () {
      api.rerender('3878eaf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/AccountInvoices.vue"
export default component.exports